.row {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-xs, 4px);
}

.notes {
  display: inline-flex;
  gap: var(--spacing-sm, 8px);
  flex-wrap: wrap;
}

.note {
  padding: var(--spacing-xs, 4px) var(--spacing-sm, 8px);
  border-radius: var(--radius-sm, 4px);
  font-family: var(--font-family-mono, ui-monospace, monospace);
}

.noteCharacteristic {
  composes: note;
  background: var(--highlight-bg, #fff3cd);
  color: var(--highlight-fg, #5d4900);
  font-weight: bold;
}

@media (prefers-reduced-motion: no-preference) {
  .noteCharacteristic {
    transition: background 200ms ease-in-out;
  }
}

.caption {
  font-size: var(--font-size-sm, 12px);
  color: var(--text-secondary, #666);
  margin: 0;
}
